/* GBI product page: buy box. Owner: X1 (v3 delta §3; v2 §B3).
   Elements: <gbi-product>, <gbi-variant-picker>, <gbi-buy-buttons>, <gbi-sticky-atc>, <gbi-manual-peek>.
   Contracts: spec §C.3 (events, root state), §C.4 (window.GBI), §C.5 (Product JSON), §C.6 (BundleState). */
(function () {
  'use strict';
  if (window.__gbiProduct) return;
  window.__gbiProduct = true;

  /* ---------- helpers ---------- */

  function core() { return window.GBI || null; }

  var localStrings = null;
  function str(key) {
    var G = core();
    if (G && G.strings && G.strings[key] != null && G.strings[key] !== '') return G.strings[key];
    if (localStrings === null) {
      localStrings = {};
      var el = document.querySelector('script[data-gbi-strings]');
      if (el) { try { localStrings = JSON.parse(el.textContent) || {}; } catch (e) { localStrings = {}; } }
    }
    return localStrings[key] != null ? localStrings[key] : '';
  }

  function t(s, vars) {
    var G = core();
    if (G && typeof G.t === 'function') return G.t(s, vars);
    vars = vars || {};
    return String(s == null ? '' : s).replace(/\[(\w+)\]/g, function (m, k) {
      return Object.prototype.hasOwnProperty.call(vars, k) ? String(vars[k]) : m;
    });
  }

  function money(cents) {
    var G = core();
    if (G && G.money && typeof G.money.format === 'function') return G.money.format(cents);
    try {
      var cfg = (G && G.config) || {};
      return new Intl.NumberFormat(cfg.locale || undefined, { style: 'currency', currency: cfg.currency || 'EUR' }).format(cents / 100);
    } catch (e) { return (cents / 100).toFixed(2); }
  }

  /* 2026-10-22 sale prices: an amount with an optional visually hidden label in front, as the Liquid prints it
     (<span class="gbi-sr">Sale price</span>€209,95). No label = the amount alone, exactly as before. */
  function setAmount(el, label, text) {
    el.textContent = text || '';
    if (!label) return;
    var sr = document.createElement('span');
    sr.className = 'gbi-sr';
    sr.textContent = label;
    el.insertBefore(sr, el.firstChild);
  }

  function track(event, params) {
    var G = core();
    if (G && typeof G.track === 'function') { try { G.track(event, params || {}); } catch (e) { /* analytics never breaks the page */ } }
  }

  function reducedMotion() {
    var G = core();
    if (G && G.mq && G.mq.reduced) return G.mq.reduced.matches;
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  var desktopMq = window.matchMedia('(min-width: 990px)');
  var phoneMq = window.matchMedia('(max-width: 749px)');
  function isDesktop() {
    var G = core();
    if (G && G.mq && G.mq.desktop) return G.mq.desktop.matches;
    return desktopMq.matches;
  }

  function onMq(mq, fn) {
    if (mq.addEventListener) mq.addEventListener('change', fn);
    else if (mq.addListener) mq.addListener(fn);
  }

  function emit(el, name, detail) {
    el.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: detail }));
  }

  /* Product JSON (§C.5): static, parsed once per root. */
  function productData(root) {
    if (!root) return null;
    if (root.__gbiData !== undefined) return root.__gbiData;
    var data = null;
    var el = root.querySelector(':scope > script[data-gbi-product-data]');
    if (el) { try { data = JSON.parse(el.textContent); } catch (e) { data = null; } }
    root.__gbiData = data;
    return data;
  }

  function findVariant(root, id) {
    var data = productData(root);
    if (!data || id == null || id === '') return null;
    var n = String(id);
    for (var i = 0; i < data.variants.length; i++) {
      if (String(data.variants[i].id) === n) return data.variants[i];
    }
    return null;
  }

  /* What the ATC (and the sticky bar) should say and add, read live from the root (§C.3). */
  function buyState(root) {
    var vid = root.dataset.variantId;
    var variant = findVariant(root, vid);
    var b = root.gbiBundle;
    var bundled = !!(b && b.kits >= 2);
    var kits = bundled ? b.kits : 1;
    var total = bundled ? b.total : (variant ? variant.price : 0);
    var status = !variant ? 'unavailable' : (variant.available ? 'ok' : 'soldout');
    return { variant: variant, bundle: b, bundled: bundled, kits: kits, total: total, status: status, tier: b && b.tier ? b.tier : 1 };
  }

  function cartItemsFor(root, st) {
    var b = st.bundle;
    var items = (st.bundled && Array.isArray(b.cartItems) && b.cartItems.length)
      ? b.cartItems.map(function (i) { return { id: Number(i.id), quantity: Number(i.quantity) }; })
      : [{ id: Number(root.dataset.variantId), quantity: 1 }];
    // 2026-10-14: the ticked display case (buy box block "addon", snippets/gbi-pdp-addon.liquid) rides along,
    // once per add, with the kit or the bundle. Accessories never count as kits for the bundle discount.
    var addon = root.querySelector('input[data-gbi-addon]:checked');
    if (addon && Number(addon.value)) items.push({ id: Number(addon.value), quantity: 1 });
    return items;
  }

  function cssMs(name, fallback) {
    var v = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
    if (!v) return fallback;
    var n = parseFloat(v);
    if (isNaN(n)) return fallback;
    return /ms$/.test(v) ? n : n * 1000;
  }

  /* ---------- <gbi-product> ---------- */

  class GbiProduct extends HTMLElement {
    connectedCallback() {
      if (this.__gbiInit) return;
      this.__gbiInit = true;
      this.sectionId = this.dataset.sectionId;
      productData(this);

      this.fixRatingLinks();
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.fixRatingLinks(), { once: true });
      }
      window.addEventListener('load', () => this.fixRatingLinks(), { once: true });

      this.addEventListener('click', (e) => this.onClick(e));
      this.addEventListener('gbi:variant-change', (e) => this.onVariantChange(e));
      this.addEventListener('gbi:bundle-change', () => {
        var per = this.querySelector('[data-gbi-price-per]');
        var b = this.gbiBundle;
        if (per) per.hidden = !(b && b.kits >= 2);
      });
    }

    /* Rating link fallback (§B3.3 rating): target → #gbi-proof → plain text. */
    fixRatingLinks() {
      this.querySelectorAll('.gbi-pdp__block--rating a.gbi-rating').forEach((a) => {
        if (a.dataset.gbiTarget === undefined) a.dataset.gbiTarget = a.getAttribute('href') || '';
        var orig = a.dataset.gbiTarget;
        if (orig && orig.charAt(0) !== '#') return; // external or relative URL: leave it alone
        if (orig.length > 1 && document.getElementById(orig.slice(1))) { a.setAttribute('href', orig); return; }
        if (document.getElementById('gbi-proof')) { a.setAttribute('href', '#gbi-proof'); return; }
        a.removeAttribute('href');
      });
    }

    onClick(e) {
      var rating = e.target.closest('.gbi-pdp__block--rating a[href^="#"]');
      if (rating) {
        var target = document.getElementById(rating.getAttribute('href').slice(1));
        track('review_strip_click', { from: 'rating' });
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: reducedMotion() ? 'auto' : 'smooth', block: 'start' });
        }
        return;
      }
      if (e.target.closest('.gbi-proofstrip__item')) track('review_strip_click', { from: 'proof' });
    }

    onVariantChange(e) {
      var d = e.detail || {};
      if (d.sectionId && String(d.sectionId) !== String(this.sectionId)) return;
      if (d.variant) this.updatePrice(d.variant);
      // 2026-10-22 sale prices: no variant for this option combination (the button says Unavailable). The price
      // text stays as it is, but the strike and the pill go, so no saving from the last version is left on screen.
      else if (d.variant === null) this.updatePrice(null);
    }

    /* Same markup as snippets/gbi-price.liquid: __now, then __was + pill while on sale (2026-10-22 sale prices:
       with the hidden "Sale price" / "Regular price" labels from data-sr-sale / data-sr-regular). */
    updatePrice(variant) {
      var wrap = this.querySelector('[data-gbi-price-wrap]');
      if (!wrap) return;
      var show = !!(variant && wrap.dataset.showCompare === 'true' && variant.compare_at_price && variant.compare_at_price > variant.price);
      var now = wrap.querySelector('[data-gbi-price]');
      if (now) {
        if (variant) setAmount(now, show ? wrap.dataset.srSale : '', variant.price_formatted || money(variant.price));
        else {
          var nowSr = now.querySelector('.gbi-sr');
          if (nowSr) nowSr.remove();
        }
      }
      var box = wrap.querySelector('.gbi-price');
      if (!box) return;
      var was = box.querySelector('[data-gbi-compare]');
      var save = box.querySelector('[data-gbi-save]');
      if (!show) {
        if (was) was.remove();
        if (save) save.remove();
        return;
      }
      if (!was) {
        was = document.createElement('s');
        was.className = 'gbi-price__was';
        was.setAttribute('data-gbi-compare', '');
        box.insertBefore(was, save || null);
      }
      setAmount(was, wrap.dataset.srRegular, money(variant.compare_at_price));
      var label = wrap.dataset.saveLabel || '';
      if (label) {
        if (!save) {
          save = document.createElement('span');
          save.className = 'gbi-pill gbi-pill--save';
          save.setAttribute('data-gbi-save', '');
          box.appendChild(save);
        }
        save.textContent = t(label, { amount: money(variant.compare_at_price - variant.price) });
      } else if (save) {
        save.remove();
      }
    }
  }

  /* ---------- <gbi-variant-picker> ---------- */

  class GbiVariantPicker extends HTMLElement {
    connectedCallback() {
      if (this.__gbiInit) return;
      this.__gbiInit = true;
      this.root = this.closest('gbi-product');
      this.addEventListener('change', (e) => {
        var input = e.target;
        if (input && input.matches('input[type="radio"]')) this.onChange(input);
      });
    }

    groups() {
      return Array.prototype.slice.call(this.querySelectorAll('fieldset[data-option-index]'));
    }

    selectedValues() {
      var values = [];
      this.groups().forEach(function (fs) {
        var idx = Number(fs.dataset.optionIndex);
        var checked = fs.querySelector('input[type="radio"]:checked');
        values[idx] = checked ? checked.value : null;
      });
      return values;
    }

    onChange(input) {
      var root = this.root;
      var data = productData(root);
      if (!data) return;
      var fs = input.closest('fieldset[data-option-index]');
      var legend = fs ? fs.querySelector('.gbi-variants__legend .gbi-label') : null;
      var values = this.selectedValues();
      var variant = null;
      for (var i = 0; i < data.variants.length; i++) {
        var v = data.variants[i];
        var match = v.options.every(function (o, j) { return o === values[j]; });
        if (match) { variant = v; break; }
      }

      this.render(values);

      root.dataset.variantId = variant ? String(variant.id) : '';
      if (variant) {
        root.querySelectorAll('input[name="id"]').forEach(function (el) {
          el.value = variant.id;
          el.dispatchEvent(new Event('change', { bubbles: true }));
        });
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState(window.history.state, '', url.toString());
        } catch (e) { /* ignore */ }
      }

      emit(root, 'gbi:variant-change', {
        sectionId: root.dataset.sectionId,
        productId: data.id,
        variant: variant,
        source: 'user'
      });
      track('version_select', {
        option: legend ? legend.textContent.trim() : '',
        value: input.value,
        variant_id: variant ? variant.id : null
      });
    }

    /* Selection marks, current values, button prices and sold-out marks (same rule as the Liquid). */
    render(values) {
      var data = productData(this.root);
      var variants = data.variants;
      // 2026-10-22 sale prices: set only when a version is on sale (snippets/gbi-pdp-variant-picker.liquid).
      var srSale = this.dataset.srSale || '';
      var srRegular = this.dataset.srRegular || '';
      this.groups().forEach(function (fs) {
        var idx = Number(fs.dataset.optionIndex);
        var current = fs.querySelector('[data-gbi-current]');
        if (current) current.textContent = values[idx] || '';
        fs.querySelectorAll('input[type="radio"]').forEach(function (input) {
          var label = input.closest('label');
          var val = input.value;
          var combo = null;
          for (var i = 0; i < variants.length; i++) {
            var v = variants[i];
            if (v.options[idx] !== val) continue;
            var ok = v.options.every(function (o, j) { return j === idx || o === values[j]; });
            if (ok) { combo = v; break; }
          }
          var show = null;
          var soldout = true;
          if (combo && combo.available) {
            show = combo;
            soldout = false;
          } else {
            variants.forEach(function (v) {
              if (v.available && v.options[idx] === val && (!show || v.price < show.price)) show = v;
            });
          }
          if (label) {
            label.classList.toggle('is-selected', input.checked);
            label.classList.toggle('is-soldout', soldout);
            var price = label.querySelector('[data-gbi-opt-price]');
            // 2026-10-22 sale prices: the struck compare-at follows the same variant as the price.
            var was = label.querySelector('[data-gbi-opt-compare]');
            var onSale = !!(was && show && show.compare_at_price && show.compare_at_price > show.price);
            if (price) {
              setAmount(price, onSale ? srSale : '', show ? (show.price_formatted || money(show.price)) : '');
              price.hidden = !show;
            }
            if (was) {
              setAmount(was, srRegular, onSale ? money(show.compare_at_price) : '');
              was.hidden = !onSale;
            }
            var prices = label.querySelector('.gbi-variants__prices');
            if (prices) prices.hidden = !show;
            var so = label.querySelector('[data-gbi-opt-soldout]');
            if (so) so.hidden = !soldout;
          }
          if (show) input.removeAttribute('aria-disabled');
          else input.setAttribute('aria-disabled', 'true');
        });
      });
    }
  }

  /* ---------- <gbi-buy-buttons> ---------- */

  class GbiBuyButtons extends HTMLElement {
    connectedCallback() {
      if (this.__gbiInit) return;
      this.__gbiInit = true;
      this.root = this.closest('gbi-product');
      if (!this.root) return;
      this.sectionId = this.dataset.sectionId || this.root.dataset.sectionId;
      this.form = this.querySelector('form');
      this.button = this.querySelector('[data-gbi-atc]');
      this.labelEl = this.querySelector('[data-gbi-atc-label]');
      this.errorEl = this.querySelector('.gbi-atc__error');
      // 2026-11-01: express checkout buttons and the Shop Pay Installments line (block settings, both optional)
      this.express = this.querySelector('[data-gbi-express]');
      this.installments = this.querySelector('[data-gbi-installments]');
      this.busy = false;
      this.root.gbiBuy = this;

      if (this.form) {
        this.form.addEventListener('submit', (e) => {
          var G = core();
          if (!G || !G.cart || typeof G.cart.add !== 'function') return; // no core: native POST to /cart/add
          e.preventDefault();
          this.add(this.button, 'buybox');
        });
      }
      this.root.addEventListener('gbi:variant-change', () => this.render());
      this.root.addEventListener('gbi:bundle-change', () => this.render());
      // Init order rule (§C.3): a bundle state may already be on the root.
      if (this.root.gbiBundle) this.render();
    }

    render() {
      if (!this.button || !this.labelEl || this.busy) return;
      var st = buyState(this.root);
      var text;
      var disabled = false;
      if (st.status === 'unavailable') { text = str('unavailable'); disabled = true; }
      else if (st.status === 'soldout') { text = str('soldOut'); disabled = true; }
      else {
        var tpl = st.kits >= 2 ? this.dataset.labelMany : this.dataset.labelOne;
        text = t(tpl, { price: money(st.total), n: st.kits });
      }
      this.labelEl.textContent = text;
      this.button.disabled = disabled;
      // Both cover one kit of the chosen version: hidden while a 2+ kit bundle is selected or it can't be bought.
      var oneKit = !st.bundled && st.status === 'ok';
      if (this.express) this.express.hidden = !oneKit;
      if (this.installments) this.installments.hidden = !oneKit;
    }

    setBusy(on, opener) {
      this.busy = on;
      var els = [this.button];
      if (opener && opener !== this.button) els.push(opener);
      els.forEach(function (el) {
        if (!el) return;
        if (on) {
          el.setAttribute('aria-busy', 'true');
          el.disabled = true;
          var lbl = el.querySelector('.gbi-btn__label');
          if (lbl) lbl.textContent = str('adding');
        } else {
          el.removeAttribute('aria-busy');
          el.disabled = false;
        }
      });
    }

    showError(msg) {
      if (!this.errorEl) return;
      this.errorEl.textContent = msg || '';
      this.errorEl.hidden = !msg;
    }

    /* The one add routine: main ATC and sticky bar (§B3.3 buy_buttons, Sticky ATC). */
    async add(opener, source) {
      if (this.busy) return;
      var G = core();
      var root = this.root;
      var st = buyState(root);
      if (st.status !== 'ok') { this.render(); return; }
      if (!G || !G.cart || typeof G.cart.add !== 'function') {
        if (this.form) this.form.submit();
        return;
      }
      var items = cartItemsFor(root, st);
      this.showError('');
      this.setBusy(true, opener);
      track('add_to_cart_click', { kits: st.kits, tier: st.tier, value: st.total });
      var addonOn = root.querySelector('input[data-gbi-addon]:checked');
      if (addonOn) track('addon_add', { variant_id: Number(addonOn.value), name: addonOn.dataset.gbiAddonName || '', source: source || 'buybox' });
      try {
        await G.cart.add(items, { opener: opener || this.button, source: source || 'buybox', sectionId: this.sectionId });
        if (st.bundled) {
          var cfg = G.config || {};
          track('bundle_add_to_cart', {
            kits: st.kits,
            tier: st.tier,
            value: st.total,
            currency: cfg.currency,
            est_saving: st.bundle.saving || 0,
            savings_mode: st.bundle.mode,
            items: items.map(function (i) { return { id: i.id, qty: i.quantity }; }),
            source: source || 'buybox'
          });
        }
      } catch (err) {
        var msg = (err && err.message) || str('cartError');
        this.showError(msg);
        if (st.bundled) track('bundle_add_error', { message: msg });
        if (source === 'sticky' && this.errorEl) {
          this.errorEl.scrollIntoView({ behavior: reducedMotion() ? 'auto' : 'smooth', block: 'center' });
        }
      } finally {
        this.setBusy(false, opener);
        this.render();
        var sticky = root.querySelector('gbi-sticky-atc');
        if (sticky && typeof sticky.render === 'function') sticky.render();
      }
    }
  }

  /* ---------- <gbi-sticky-atc> ---------- */

  class GbiStickyAtc extends HTMLElement {
    connectedCallback() {
      if (this.__gbiInit) return;
      this.__gbiInit = true;
      this.root = this.closest('gbi-product');
      if (!this.root) return;
      this.sectionId = this.dataset.sectionId || this.root.dataset.sectionId;
      this.btn = this.querySelector('.gbi-sticky__btn');
      this.labelEl = this.querySelector('[data-gbi-sticky-label]');
      // above: the main ATC has scrolled above the viewport (mobile rule).
      // partial: the main ATC is not fully visible, above or below the fold (desktop rule, v3 §3.8).
      this.state = { above: false, partial: false, footer: false, locked: false };
      this.visible = false;
      this.hideTimer = null;

      this.render();
      onMq(phoneMq, () => this.render());

      var atc = document.getElementById('GbiAtc-' + this.sectionId);
      if (!atc || !('IntersectionObserver' in window)) return;
      this.atc = atc;

      this.atcObserver = new IntersectionObserver(() => this.measure(), { threshold: [0, 1] });
      this.atcObserver.observe(atc);
      // A jump across the ATC (anchor link, restored scroll) can cross no threshold, so the
      // observer stays silent. A passive, rAF-throttled scroll and resize check covers that case.
      this.ticking = false;
      this.onScroll = () => {
        if (this.ticking) return;
        this.ticking = true;
        requestAnimationFrame(() => {
          this.ticking = false;
          this.measure();
        });
      };
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });
      var hdrEl = document.querySelector('gbi-header');
      if (hdrEl && 'MutationObserver' in window) {
        this.hdrObserver = new MutationObserver(this.onScroll);
        this.hdrObserver.observe(hdrEl, { attributes: true, attributeFilter: ['class', 'data-state'] });
      }

      // The theme footer, not a <footer> inside our own dialogs/sheets (the kit
      // picker renders a <footer class="gbi-sheet__foot"> before the page footer).
      var footer = document.querySelector('.shopify-section-group-footer-group') ||
        Array.prototype.find.call(document.querySelectorAll('footer, .footer'), function (el) {
          return !el.closest('dialog, .gbi-sheet, gbi-product');
        }) || null;
      if (footer) {
        this.footerObserver = new IntersectionObserver((entries) => {
          entries.forEach((en) => { this.state.footer = en.isIntersecting; });
          this.update();
        });
        this.footerObserver.observe(footer);
      }

      var html = document.documentElement;
      this.state.locked = html.classList.contains('gbi-lock');
      this.lockObserver = new MutationObserver(() => {
        var locked = html.classList.contains('gbi-lock');
        if (locked !== this.state.locked) { this.state.locked = locked; this.update(); }
      });
      this.lockObserver.observe(html, { attributes: true, attributeFilter: ['class'] });

      onMq(desktopMq, () => this.update());

      if (this.btn) {
        this.btn.addEventListener('click', () => {
          track('sticky_atc_click');
          var buy = this.root.gbiBuy || this.root.querySelector('gbi-buy-buttons');
          if (buy && typeof buy.add === 'function') buy.add(this.btn, 'sticky');
        });
      }
      this.root.addEventListener('gbi:variant-change', () => this.render());
      this.root.addEventListener('gbi:bundle-change', () => this.render());
      if (this.root.gbiBundle) this.render();
    }

    disconnectedCallback() {
      if (this.atcObserver) this.atcObserver.disconnect();
      if (this.footerObserver) this.footerObserver.disconnect();
      if (this.lockObserver) this.lockObserver.disconnect();
      if (this.hdrObserver) this.hdrObserver.disconnect();
      if (this.onScroll) {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
      }
      this.__gbiInit = false;
    }

    /* Reads the main ATC position. A hidden ATC (0×0 box) counts as visible, so the bar stays away. */
    /* The GBI header's floating bar covers the top of the screen while it is condensed and not tucked away:
       an ATC under it counts as gone (QA M6), so the sticky bar shows instead of a hidden button. */
    topCover() {
      var hdr = this.hdr || (this.hdr = document.querySelector('gbi-header'));
      if (!hdr || hdr.getAttribute('data-state') !== 'condensed' || hdr.classList.contains('is-tucked')) return 0;
      var v = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--gbi-sticky-top'));
      return v > 0 ? v : 0;
    }

    measure() {
      if (!this.atc) return;
      var r = this.atc.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var hasBox = r.width > 0 || r.height > 0;
      var top = this.topCover();
      var above = hasBox && r.bottom < top;
      var partial = hasBox && (r.top < top || r.bottom > vh);
      if (above !== this.state.above || partial !== this.state.partial) {
        this.state.above = above;
        this.state.partial = partial;
        this.update();
      }
    }

    allowed() {
      return isDesktop() ? this.classList.contains('gbi-sticky--desktop') : this.classList.contains('gbi-sticky--mobile');
    }

    update() {
      var s = this.state;
      var trigger = isDesktop() ? s.partial : s.above;
      var want = this.allowed() && trigger && !s.footer && !s.locked;
      if (want === this.visible) return;
      this.visible = want;
      clearTimeout(this.hideTimer);
      if (want) {
        this.hidden = false;
        requestAnimationFrame(() => requestAnimationFrame(() => { if (this.visible) this.classList.add('is-visible'); }));
      } else {
        this.classList.remove('is-visible');
        var dur = reducedMotion() ? 0 : cssMs('--gbi-dur', 220);
        this.hideTimer = setTimeout(() => { if (!this.visible) this.hidden = true; }, dur);
      }
    }

    render() {
      var root = this.root;
      var st = buyState(root);
      var data = productData(root);
      var vEl = this.querySelector('[data-gbi-sticky-variant]');
      var kEl = this.querySelector('[data-gbi-sticky-kits]');
      var pEl = this.querySelector('[data-gbi-sticky-price]');
      var vText = '';
      if (st.variant && data && data.variants.length > 1) {
        // Phones keep the meta short (MOB-1): the first option value only, then the kits.
        vText = phoneMq.matches ? String(st.variant.options[0] || '') : st.variant.options.join(' · ');
      }
      if (vEl) vEl.textContent = vText ? ' · ' + vText : '';
      if (kEl) kEl.textContent = st.kits >= 2 ? t(str('kitsMany'), { n: st.kits }) : '';
      this.renderThumbs(st, data);
      if (pEl && st.status !== 'unavailable') pEl.textContent = money(st.total);
      if (!this.btn || this.btn.getAttribute('aria-busy') === 'true') return;
      var label = this.dataset.label || '';
      var disabled = false;
      if (st.status === 'unavailable') { label = str('unavailable'); disabled = true; }
      else if (st.status === 'soldout') { label = str('soldOut'); disabled = true; }
      if (this.labelEl) this.labelEl.textContent = label;
      this.btn.disabled = disabled;
    }
  }

  /* v3.5: thumbnails of the chosen kits (no names). */
  GbiStickyAtc.prototype.renderThumbs = function (st, data) {
    var ul = this.querySelector('[data-gbi-sticky-thumbs]');
    if (!ul) return;
    var imgs = [];
    if (st.bundled && st.bundle && Array.isArray(st.bundle.units)) {
      st.bundle.units.forEach(function (u) { imgs.push(u.image || ''); });
    } else {
      imgs.push((st.variant && st.variant.image) || (data && data.image) || '');
    }
    imgs = imgs.slice(0, 4);
    var sig = imgs.join('|');
    if (ul.dataset.sig === sig) return;
    var first = !ul.dataset.sig;
    ul.dataset.sig = sig;
    if (first && imgs.length === 1 && ul.children.length === 1) return; // keep the Liquid thumb (srcset, sizes)
    ul.textContent = '';
    imgs.forEach(function (src) {
      var li = document.createElement('li');
      li.className = 'gbi-sticky__thumb';
      if (src) {
        var img = document.createElement('img');
        img.src = src;
        img.alt = '';
        img.width = 40;
        img.height = 40;
        img.decoding = 'async';
        li.appendChild(img);
      }
      ul.appendChild(li);
    });
    ul.classList.toggle('is-many', imgs.length > 1);
  };

  /* ---------- <gbi-manual-peek> ---------- */

  class GbiManualPeek extends HTMLElement {
    connectedCallback() {
      if (this.__gbiInit) return;
      this.__gbiInit = true;
      var dlg = this.closest('dialog');
      var pages = this.querySelector('.gbi-peek__track');
      if (dlg && pages) {
        dlg.addEventListener('gbi:dialog-open', function () { pages.scrollLeft = 0; });
      }
    }
  }

  /* The trigger can live in a clone inside #GbiDrawer (outside <gbi-product>), so bind on document (§B3.3). */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest ? e.target.closest('[data-gbi-manual-peek-open]') : null;
    if (!trigger) return;
    var G = core();
    var id = trigger.getAttribute('data-gbi-peek-target');
    var dlg = (id && document.getElementById(id)) || document.querySelector('dialog.gbi-peek');
    if (!dlg || !G || !G.dialog || typeof G.dialog.open !== 'function') return;
    e.preventDefault();
    G.dialog.open(dlg, { opener: trigger, history: true });
    track('manual_peek_open');
  });

  /* ---------- <gbi-proof-ticker> (v3.6) ----------
     One review at a time under the add-to-cart. Native scroll-snap does the swipe; this element
     adds autoplay, dots and a pause button. Autoplay only while on screen and not hovered,
     focused or touched; never with reduced motion. Tracks review_strip_click on interaction. */
  class GbiProofTicker extends HTMLElement {
    connectedCallback() {
      if (this.__gbiInit) return;
      this.__gbiInit = true;
      this.track = this.querySelector('.gbi-proofbar__track');
      this.items = this.track ? Array.prototype.slice.call(this.track.children) : [];
      this.index = 0;
      this.userPaused = false;
      this.hover = false;
      this.focusIn = false;
      this.onScreen = false;
      this.ms = Math.max(3, Number(this.dataset.interval) || 5) * 1000;
      var n = this.items.length;
      var slideTpl = this.dataset.strSlide || '';
      this.items.forEach((li, i) => { if (slideTpl) li.setAttribute('aria-label', t(slideTpl, { x: i + 1, n: n })); });
      if (n < 2) return;

      var dotsEl = this.querySelector('[data-gbi-proof-dots]');
      this.dots = [];
      if (dotsEl) {
        this.items.forEach((li, i) => {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'gbi-proofbar__dot';
          if (slideTpl) b.setAttribute('aria-label', t(slideTpl, { x: i + 1, n: n }));
          b.addEventListener('click', () => { this.go(i, true); this.userAct(); });
          dotsEl.appendChild(b);
          this.dots.push(b);
        });
      }
      this.toggle = this.querySelector('[data-gbi-proof-toggle]');
      if (this.toggle) {
        if (reducedMotion()) { this.toggle.hidden = true; this.userPaused = true; }
        this.toggle.addEventListener('click', () => {
          this.userPaused = !this.userPaused;
          this.syncToggle();
          this.schedule();
        });
      }
      this.addEventListener('pointerenter', () => { this.hover = true; this.schedule(); });
      this.addEventListener('pointerleave', () => { this.hover = false; this.schedule(); });
      this.addEventListener('focusin', () => { this.focusIn = true; this.schedule(); });
      this.addEventListener('focusout', (e) => { if (!this.contains(e.relatedTarget)) { this.focusIn = false; this.schedule(); } });
      this.track.addEventListener('touchstart', () => this.userAct(), { passive: true });
      var st = null;
      this.track.addEventListener('scroll', () => {
        clearTimeout(st);
        st = setTimeout(() => {
          var w = this.track.clientWidth || 1;
          var i = Math.round(this.track.scrollLeft / w);
          if (i !== this.index) { this.index = Math.max(0, Math.min(n - 1, i)); this.syncDots(); this.schedule(); }
        }, 80);
      }, { passive: true });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver((entries) => {
          this.onScreen = entries.some((en) => en.isIntersecting);
          this.schedule();
        }, { threshold: 0.6 }).observe(this);
      } else {
        this.onScreen = true;
      }
      document.addEventListener('visibilitychange', () => this.schedule());
      this.syncDots();
      this.syncToggle();
      this.schedule();
    }
    userAct() {
      if (!this.tracked) { this.tracked = true; track('review_strip_click', { from: 'ticker' }); }
    }
    go(i, smooth) {
      var n = this.items.length;
      this.index = (i + n) % n;
      var w = this.track.clientWidth;
      try { this.track.scrollTo({ left: this.index * w, behavior: smooth && !reducedMotion() ? 'smooth' : 'auto' }); } catch (e) { this.track.scrollLeft = this.index * w; }
      this.syncDots();
    }
    syncDots() {
      (this.dots || []).forEach((d, i) => {
        d.classList.toggle('is-active', i === this.index);
        if (i === this.index) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
      });
    }
    syncToggle() {
      if (!this.toggle) return;
      var p = this.toggle.querySelector('.gbi-proofbar__ico-pause');
      var pl = this.toggle.querySelector('.gbi-proofbar__ico-play');
      if (p) p.hidden = this.userPaused;
      if (pl) pl.hidden = !this.userPaused;
      this.toggle.setAttribute('aria-label', (this.userPaused ? this.dataset.strPlay : this.dataset.strPause) || '');
    }
    schedule() {
      clearTimeout(this.timer);
      var run = !this.userPaused && !this.hover && !this.focusIn && this.onScreen && !document.hidden && !reducedMotion();
      if (!run) return;
      this.timer = setTimeout(() => { this.go(this.index + 1, true); this.schedule(); }, this.ms);
    }
    disconnectedCallback() { clearTimeout(this.timer); }
  }

  function define(name, cls) {
    if (!customElements.get(name)) customElements.define(name, cls);
  }
  define('gbi-proof-ticker', GbiProofTicker);
  define('gbi-product', GbiProduct);
  define('gbi-variant-picker', GbiVariantPicker);
  define('gbi-buy-buttons', GbiBuyButtons);
  define('gbi-sticky-atc', GbiStickyAtc);
  define('gbi-manual-peek', GbiManualPeek);

  /* ---------- Difficulty (i) tip (2026-10-14): one open at a time; outside tap or Esc closes it ---------- */
  document.addEventListener('click', function (e) {
    document.querySelectorAll('details[data-gbi-tip][open]').forEach(function (d) {
      if (!d.contains(e.target)) d.open = false;
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('details[data-gbi-tip][open]').forEach(function (d) {
      var inside = d.contains(document.activeElement);
      d.open = false;
      if (inside) { var s = d.querySelector('summary'); if (s) s.focus(); }
    });
  });
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d || !d.matches || !d.matches('details[data-gbi-tip]') || !d.open) return;
    track('level_info_open', { level: (d.querySelector('.gbi-tip__title') || {}).textContent || '' });
  }, true);
})();
